import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

export type PatientFilterPanelFormBean = {
   patientGroups: PatientGroup[];
};

export enum PatientFilterPanelSearchParam {
   PATIENT_GROUPS = 'oznaczenie-pacjenta',
}

export enum PatientFilterPanelStorageKey {
   PATIENT_GROUPS = 'patientGroups',
}
